import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricCreateButtonProps = Pick<TouchTargetProps, 'behavior'>;

const EditRubricCreateButtonIcon: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.25 3.75012H4.5C4.10218 3.75012 3.72064 3.90816 3.43934 4.18946C3.15804 4.47077 3 4.8523 3 5.25012V13.5001C3 13.8979 3.15804 14.2795 3.43934 14.5608C3.72064 14.8421 4.10218 15.0001 4.5 15.0001H12.75C13.1478 15.0001 13.5294 14.8421 13.8107 14.5608C14.092 14.2795 14.25 13.8979 14.25 13.5001V9.75012M13.1895 2.68962C13.3279 2.54636 13.4934 2.43208 13.6764 2.35347C13.8594 2.27486 14.0562 2.23348 14.2554 2.23175C14.4546 2.23002 14.6521 2.26797 14.8364 2.34339C15.0208 2.41881 15.1883 2.53019 15.3291 2.67103C15.4699 2.81187 15.5813 2.97935 15.6567 3.16369C15.7322 3.34804 15.7701 3.54555 15.7684 3.74472C15.7666 3.94389 15.7253 4.14072 15.6467 4.32373C15.568 4.50673 15.4538 4.67225 15.3105 4.81062L8.871 11.2501H6.75V9.12912L13.1895 2.68962Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditRubricCreateButton: React.FC<EditRubricCreateButtonProps> = ({
  behavior,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricCreateButtonLabel()}
      icon={<EditRubricCreateButtonIcon />}
      behavior={behavior}
    />
  );
};
